/*
 * Copyright (c) 2024 Ask Sage, Inc. All rights reserved.
 * This software is the confidential and proprietary information of Ask Sage, Inc.
 * You shall not disclose such confidential information and shall use it only in
 * accordance with the terms of the license agreement you entered into with Ask Sage, Inc.
 * THIS SOFTWARE IS PROVIDED "AS IS" AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 * INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL ASK SAGE, INC.
 * OR ITS CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 * EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT
 * OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
 * STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 * You may not use this software except in compliance with the License.
 * You may not modify, reverse engineer, or redistribute this software.
 */
import React, { useState, useEffect, useRef } from 'react';
import { getWithExpiry, getBotSettingItem, isBotLoggedIn, createChat, deleteChat, updateChatTitle, updateChat, getChats, getName, logout, getToken, getUser, setWithExpiry } from '../AuthService'
import { parseToolCalls, parseMessage} from '../Utils/GenAI_helper'
import * as default_data from '../config.js'
import { v4 as uuidv4 } from "uuid";
import Modal from 'react-modal';
import { urlify, strip, unEscapeHTML, escapeHTML } from '../Utils/text_functions.js'
import * as log from 'loglevel'
import { FileManagementDialog } from '../Popups/FileManagement/FileManagementDialog.js';
import { Box, IconButton, Stack, useMediaQuery, useTheme } from '@mui/material';
import { useUserSettings } from '../Contexts/UserPreferenceContext.js';
import { Navbar } from './Navbar.js';
import { getBannerColor } from '../Utils/classification_helper.js';
import { checkMode } from '../Utils/chatHelpers.js';
import { CoreChatContainer } from '@asksage/core-ui';

const Home = ({ currentDatasetMode }) => {
    const [currentMode, setCurrentMode] = useState("advanced");
    const [chatInput, setChatInput] = useState("simple");
    const [currentModel, setCurrentModel] = useState("gpt");
    const [firstname, setName] = useState("");

    const [loadingText, setLoadingText] = useState("Getting things ready...");    

    const [paid, setPaid] = useState(false);
    const [hasStripeID, sethasStripeID] = useState(false);
    const [cur_user, setUser] = useState(null);
    const [CACAuth, setCACAuth] = useState(false);
    const [CUIAuth, setCUIAuth] = useState(false);

    const deepAgentSidebarRef = useRef();
    const closeSidebar = () => {
      if (deepAgentSidebarRef.current) {
        deepAgentSidebarRef.current.closeDrawer();
      }
    };
    const [chatMode, setChatMode] = useState('chat');        
    const [deep_agent_id, setDeepAgentID] = useState(null);  

    const [files, setFiles] = useState([]);    

    const [currentChatIndex, setRCurrentChatIndex] = useState(0);
    const currentChatIndexRef = useRef(currentChatIndex);
    
    const [currentChats, setRCurrentChats] = useState([]);
    const currentChatsRef = useRef(currentChats);

    const [chatButton, setRChatButton] = useState([]);
    const chatButtonRef = useRef(chatButton)

    const [chatLog, setRChatLog] = useState([]);
    const chatLogRef = useRef(chatLog)

    const [isLoading, setIsLoading] = useState(false);
    
    const [personas, setPersonas] = useState([]);
    const [current_persona, setCurrentPersona] = useState(1);

    const [datasets, setDatasets] = useState([]);
    const [datasetPermissions, setDatasetPermissions] = useState([]);
    const [datasetEditOnly, setDatasetEditOnly] = useState([]);
    const [secrets, setSecrets] = useState([]);
    const [current_dataset, setCurrentDataset] = useState([{value: 'all', label: 'All'}]);
    const  [finalMessages, setFinalMessages] = useState([]);


    const [loaded, setLoaded] = useState(false);
    var loaded_static = false;

    const showSubscribeBanner = (paid != true && default_data.default_customer_tenant !== true) || (cur_user && cur_user.plan_type && cur_user.plan_type === 'trial')

    const {state, dispatch} = useUserSettings();
    
    const theme = useTheme();

    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    
  

    function setCurrentChatIndex(index) {
      setRCurrentChatIndex(index);
      currentChatIndexRef.current = index;      
    }

    function setChatButton(button) {
      setRChatButton(button);
      chatButtonRef.current = button;      
    }

    function setCurrentChats(chats) {
      setRCurrentChats(chats);
      currentChatsRef.current = chats;      
    }

    function setChatLog(chats) {
      setRChatLog(chats);
      chatLogRef.current = chats;      
    }

    function loadPersonas() {
      var token = getToken()
      if(token === false) {
          logout()        
          return;
      }
    
      fetch(default_data.default_chat_service_url + '/get-personas', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-tokens': `${token}`
        },        
        body: JSON.stringify({
        })
      })
        .then(response => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('An error occurred while getting data.');
        })
        .then(data => {
          var res = data.response;
          if(data != null && data.status == '200') {            
            res.sort((a, b) => {
              const nameA = a['name'].toUpperCase();
              const nameB = b['name'].toUpperCase();
              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }
              return 0;
            });
            setPersonas(res)
          }
          else if(data != null && data.status == '400') {
            if(data.response.indexOf('Token is invalid') > -1) {
              logout()
            }
          }            
        })
        .catch(error => {
          console.log(error);
        });
    }  

    function loadDatasets() {
      var token = getToken()
      if(token === false) {
          logout()
          return;
      }
    
      fetch(default_data.default_user_service_url_no_cac + '/get-datasets-with-permissions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-tokens': `${token}`
        },        
        body: JSON.stringify({
        })
      })
        .then(response => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('An error occurred while getting data.');
        })
        .then(data => {
          if(data != null && data.status == '200') {            
            var res = data.response;

            var names = res.map(item => item.dataset);

            names.sort((a, b) => {
              const nameA = a.toUpperCase();
              const nameB = b.toUpperCase();
              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }
              return 0;
            });
            setDatasets(names);
            setDatasetPermissions(res);

            var edit_only = res.filter(item => item.permissions === 'edit' || item.permissions === 'owner' || item.permissions === 'admin');
            var edit_only_names = edit_only.map(item => item.dataset);

            setDatasetEditOnly(edit_only_names);
          }
        })
        .catch(error => {
          console.log(error);
        });
    }

    function loadSecrets() {
      var token = getToken()
      if(token === false) {
          logout()
          return;
      }
    
      fetch(default_data.default_chat_service_url + '/get-secrets', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-tokens': `${token}`
        },        
        body: JSON.stringify({
        })
      })
        .then(response => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('An error occurred while getting data.');
        })
        .then(data => {
          var res = data.response;
          if(data != null && data.status == '200' && res != null) {            
            res.sort((a, b) => {
              const nameA = a.toUpperCase();
              const nameB = b.toUpperCase();
              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }
              return 0;
            });
            setSecrets(res)
          }
        })
        .catch(error => {
          console.log(error);
        });
    }  

    async function loadChats() {
    
      var chats = await getChats()
      if (chats === null) {
        setCurrentChats([]);
        setChatButton([]);
        setIsLoading(false);
        return;
      }
    
      for (const element of chats.chats) {
        for (const sub_element of element.content) {
          if (sub_element.message_orig !== undefined && sub_element.message_orig !== null && sub_element.message_orig !== '') {
            var parsed_message = await parseMessage(random_element, unEscapeHTML(sub_element.message_orig));
            sub_element.message = parsed_message['message'];
            sub_element.images = parsed_message['images'];
          }
          var ret_parse_tools = parseToolCalls(sub_element)
          if(ret_parse_tools !== null) {
            sub_element.message = ret_parse_tools['message'];
            sub_element.code = ret_parse_tools['code'];
            sub_element.content = ret_parse_tools['content'];
          }
          if (sub_element.message !== undefined && sub_element.message !== null && sub_element.message.indexOf('<convert_code>') !== -1) {
            sub_element.message = loadPendingCode(sub_element.message);
          }
        }
      }
      
      setCurrentChats(chats.chats);
      setChatButton(chats.buttons);

      // loop through chats to find a chat that is not code

      var found = false;
      for (const element of chats.chats) {
        if(checkMode(chats.chats, element.id, 'chat')) {
          changeChat(element.id.toString(), chats.chats);
          found = true;
          break;
        }
      }

      if(chats.chats.length === 0 || found === false) {
        newChat()
      }
      setIsLoading(false);
    }
    
    useEffect(() => {
        if(loaded || loaded_static) {
          return;
        }
      
        setLoaded(true)
        loaded_static = true;

        if(getWithExpiry('loss-pass') === true) {
          window.location = '/update?action=force_password';
          return;
        }

        if(getWithExpiry('currentMode') !== null && getWithExpiry('currentMode') === 'simple') {
          setCurrentMode('simple');
        }

        loadChats()

        loadPersonas()
        setInterval(loadPersonas, 10 * 60 * 1000);

        loadDatasets()
        loadSecrets()
        var user = getUser()
        if(isBotLoggedIn()) {
          if(getBotSettingItem('force_new_chat') === true) {         
            clearChat()
          }
        }                

        setPaid(user.paid)
        if(user.stripe_customer_id != null && user.stripe_customer_id != '') {
          sethasStripeID(true)
        }
        else {
          sethasStripeID(false)
        }

        var model_first = state.defaultModel
        if(model_first === 'auto' && user.paid != true) {
          setCurrentModel(default_data.default_allowed_models[1])
        }
        else {
          setCurrentModel(model_first)
        }

        setUser(user)

        setCUIAuth(false)
        if(user.cac_auth && (user.cac_auth === 'true' || user.cac_auth === true)) {
          setCACAuth(true)
          setCUIAuth(true)
        } 
        else {  
          setCACAuth(false) 
          setCUIAuth(false)
        }

        if(user.is_cui_mfa_authorized && user.is_cui_mfa_authorized === true && user.mfa_auth && (user.mfa_auth === 'true' || user.mfa_auth === true)) {
          setCUIAuth(true)
        } 
        
        setName(getName())
        loadChatLog()
        setCurrentPersona(state.defaultPersonality)
        // check local storage for chat input
        var chatInput = localStorage.getItem('chatInput');
        if (chatInput !== null) {
          setChatInput(chatInput);
        } else {
          localStorage.setItem('chatInput', 'simple');
        }
    }, [])
  
  useEffect(() => {
    setCurrentDataset(state.defaultDatasets)
  }, [state])

  // clear chats
  function clearChat(){
    setFiles([]);
    setFinalMessages([]);
    setChatMode('chat')
    setDeepAgentID(null)
    closeSidebar();
    setChatLogAndSave([{ user: "gpt", message: `Welcome, how can I help you?`, added_obj: null }], currentChatIndex, false);
  }

  function newChat(){
    var new_index = uuidv4();
    setFiles([]);
    setCurrentChatIndex(new_index)
    changeChat(new_index)
    setChatMode('chat')
    setDeepAgentID(null)
    closeSidebar();
    setChatLogAndSave([{ user: "gpt", message: `Welcome, how can I help you?`, added_obj: null}], new_index, false, true)
  }
  var random_element = document.createElement('div');

  function loadChatLog() {
    if(currentChatsRef.current.lenght === 0) {
      return setChatLog([{ user: "gpt", message: `Welcome, how can I help you?`, added_obj: null}])
    }
    else {
      const curChat = currentChatsRef.current[0]
      if(curChat != null) {
        setCurrentChatIndex(curChat.id)
        setChatLog(curChat.content)
      }        
    }
  }

  function changeChat(chatId, updatedChats = null) {
    setCurrentChatIndex(chatId);
    setFinalMessages([]);

    // Default behavior for regular chats
    setChatMode('chat');
    setDeepAgentID(null);
    closeSidebar();

    if (updatedChats === null) {
      updatedChats = currentChatsRef.current;
    }
    
    const curChat = updatedChats.find(a => a.id.toString() === chatId.toString());
    if (curChat != null) {
      setChatLog(curChat.content);    
      if (curChat.content.length > 0) {
        const lastEntry = curChat.content[curChat.content.length - 1];
        if (lastEntry.type === "deep_agent_action" && lastEntry.deep_agent_id !== null) {
          setDeepAgentID(lastEntry.deep_agent_id);
          setChatMode('deep_agent');
        }
      }
    }
  }

  function setChatLogAndSave(chatLog, index=currentChatIndex, no_save=false, force_visible=false) {
    index = index.toString();
    
    updateChatData(chatLog, index);

    // Only update the UI if this chat is currently active.
    updateVisibleChat(chatLog, index, force_visible);

    var newButton = [...chatButtonRef.current];
    const curButton = newButton.find(a => a.key === index);
    if(curButton != null) {      
      if (curButton.content.substring(0, 5) === "Chat ") {
        curButton.content = "Chat " + new Date().toLocaleString(); 
        setChatButton(newButton);
      }
      if(no_save === false) {
        if(!updateChat(index, curButton.content, chatLog)) {
          log.error('updateChat: failed to update chat ' + index)
        }
      }
    }
    else {
      var cur_title = "Chat " + new Date().toLocaleString();
      newButton = [ 
        { key: index, content: cur_title }, // and one new item at the end        
        ...chatButtonRef.current // that contains all the old items        
      ]
      setChatButton(newButton);
      if(no_save === false) {
        if(!createChat(index, cur_title, chatLog)) {
          log.error('createChat: failed to create chat')
        }
      }
    }
    return chatLog
  }

  function updateChatData(newChatLog, index) {
    index = index.toString();

    var newChat = [...currentChatsRef.current];
    const curChat = newChat.find(a => a.id === index);
    if(curChat != null) {
      curChat.content = newChatLog; 
      setCurrentChats(newChat);
    }
    else {
      newChat = [ 
        { id: index, content: newChatLog }, // and one new item at the end
        ...currentChatsRef.current // that contains all the old items
      ]
      setCurrentChats(newChat);
    }
  }

  function updateVisibleChat(chatLog, index, force_visible) {
    if (force_visible === true || index.toString() === currentChatIndexRef.current.toString()) {
      setChatLog(chatLog); 
    }
  } 

  function loadPendingCode(message) {
    var body = null;
  
    if(message.indexOf('</convert_code>') !== -1) {
      message = message.replace(/<br \/>/g, '\n');
  
      let parser = new DOMParser();
      const doc = parser.parseFromString(message, 'text/html');
  
      var codes = doc.getElementsByTagName('convert_code');
      [...codes].forEach((code) => {
        // horizontal scroll if too long
        var code_inner = code.innerHTML;
  
        random_element.innerHTML = code_inner;              
        code_inner = random_element.textContent;        
        code_inner = window.hljs.highlightAuto(code_inner).value
  
        // Create a new 'code' element and copy the contents of 'convert_code' into it
        const newCode = document.createElement('code');
        newCode.innerHTML = code_inner;
  
        const div = document.createElement('pre');
        div.className = "code_pre"
        const parent = code.parentElement;
  
        if(parent != null) {
          // Replace the 'convert_code' element with the new 'code' element
          parent.replaceChild(div, code);
          div.appendChild(newCode);  
          const copyButton = document.createElement('button');
          copyButton.className = "code_button";
          copyButton.innerText = 'Copy';  
          // Append the copy button to the <code> tag
          div.appendChild(copyButton);  
        }
        else {
        }
      });
      body = doc.getElementsByTagName('body');
      if(body.length != 0) {
        message = body[0].innerHTML;
      }
      else {
        message = doc.documentElement.innerHTML;
      }
      return message;            
    }
  }

  const loading_styles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'rgba(0, 0, 0, 0.9)', // Adjust the opacity as needed
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999, // Adjust the z-index as needed to ensure it appears above other elements
    },
    loadingText: {
      color: '#fff',
      fontSize: '24px',
    },
  };


  Modal.setAppElement('#root');

  const getBannerHeight = () => {
    if(isMobile) {
      if (showSubscribeBanner) {
        return 'calc(100dvh - 100px)';
      }
      return 'calc(100dvh - 66px)';  
    }
    else {
      if (showSubscribeBanner) {
        return 'calc(100dvh - 50px)';
      }
      return 'calc(100dvh - 16px)';
    }
  }

  return (
  <Box 
    className="AppContainer" 
    sx={{
      backgroundColor: theme.palette.appBackground,
    }}
  >
    {
      isBotLoggedIn() && getBotSettingItem('hide_banner') === true ?
      '' :
      (CUIAuth === true) ?
      <div className={`header-message ${getBannerColor(CUIAuth)}`}>
        { default_data.default_banner_override != null && default_data.default_banner_override != '' ?
            default_data.default_banner_override : 'CUI'
        }
      </div>
      :
      <div className={`header-message ${getBannerColor(CUIAuth)}`}>
        { default_data.default_banner_override != null && default_data.default_banner_override != '' ?
            default_data.default_banner_override : 'UNCLASSIFIED'
        }
      </div>
    }
    {
      showSubscribeBanner && (
        <div className="header_subscribe">
          <a href="/payment">{default_data.default_subscribe_banner_text}</a>
        </div>
      )
    }
    <Stack 
      direction={ isMobile ? 'column' : 'row' }
      sx={{
        width: '100vw',
        height: getBannerHeight(), 
      }}
    > 
      {!isMobile && <Navbar/>}
      <div style={{display: 'flex', height: '100%', width:'100%'}} className={` ${((paid != true && default_data.default_customer_tenant !== true) || (cur_user && cur_user.plan_type && cur_user.plan_type === 'trial')) ? 'longer' : ''} ${isBotLoggedIn() ? 'bot' : ''}`}>
        <CoreChatContainer
          userState={state}
          default_data={default_data}
          getWithExpiry={getWithExpiry}
          getChats={getChats}
          getBotSettingItem={getBotSettingItem}
          getName={getName}
          getToken={getToken}
          getUser={getUser}
          isBotLoggedIn={isBotLoggedIn}
          setWithExpiry={setWithExpiry}
          logout={logout}
          updateChat={updateChat}
          updateChatTitle={updateChatTitle}
          deleteChat={deleteChat}
          Navbar={Navbar}
          widthOffset={47}
        />
      </div>
    </Stack>
    {/* Loading overlay */}
    {isLoading && (
      <div style={loading_styles.overlay}>
        <span style={loading_styles.loadingText}>{loadingText}</span>
      </div>
    )}
  </Box>
);
}

export default Home;
